import { render, staticRenderFns } from "./_base-author-course-curriculum.vue?vue&type=template&id=2ab00cb2"
import script from "./_base-author-course-curriculum.vue?vue&type=script&lang=js"
export * from "./_base-author-course-curriculum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports